import { banco } from '../db/banco'
import { arredondar2 } from '../pedidos/precos'
import { dentroDoPeriodo } from '../metas/calculo'
import { valorEfetivo } from './motor'

export interface ResumoComissoes {
  porRepresentada: Array<{
    representada_id: string
    previsto: number
    liberado: number
    recebido: number
  }>
  totais: { previsto: number; liberado: number; recebido: number; pendente: number }
}

export async function resumoComissoes(inicio: string, fim: string): Promise<ResumoComissoes> {
  const lancamentos = await banco.lancamentos_comissao
    .filter((l) => l.apagado_em === null)
    .toArray()
  const mapa = new Map<string, { previsto: number; liberado: number; recebido: number }>()
  const totais = { previsto: 0, liberado: 0, recebido: 0, pendente: 0 }

  for (const lancamento of lancamentos) {
    const subPedido = await banco.sub_pedidos.get(lancamento.sub_pedido_id)
    if (!subPedido || subPedido.apagado_em !== null) continue
    const pedido = await banco.pedidos.get(subPedido.pedido_id)
    if (!pedido || !dentroDoPeriodo(pedido.data, inicio, fim)) continue

    const grupo = mapa.get(subPedido.representada_id) ?? { previsto: 0, liberado: 0, recebido: 0 }
    if (lancamento.status === 'prevista') {
      grupo.previsto += valorEfetivo(lancamento)
      totais.previsto += valorEfetivo(lancamento)
    } else if (lancamento.status === 'liberada') {
      grupo.liberado += valorEfetivo(lancamento)
      totais.liberado += valorEfetivo(lancamento)
    } else {
      grupo.recebido += lancamento.valor_recebido ?? valorEfetivo(lancamento)
      totais.recebido += lancamento.valor_recebido ?? valorEfetivo(lancamento)
    }
    mapa.set(subPedido.representada_id, grupo)
  }

  totais.previsto = arredondar2(totais.previsto)
  totais.liberado = arredondar2(totais.liberado)
  totais.recebido = arredondar2(totais.recebido)
  totais.pendente = arredondar2(totais.previsto + totais.liberado)

  return {
    porRepresentada: [...mapa.entries()]
      .map(([representada_id, valores]) => ({
        representada_id,
        previsto: arredondar2(valores.previsto),
        liberado: arredondar2(valores.liberado),
        recebido: arredondar2(valores.recebido),
      }))
      .sort((a, b) => a.representada_id.localeCompare(b.representada_id)),
    totais,
  }
}
